<template>
    <div class="grow w-full lg:max-w-md">
        <vx-filterable :active="active" @toggle="toggleFilterable" data-test="flows-filters">
            <template v-slot:placeholder>
                <span class="mr-2">Find</span>
                <vx-badge
                    v-if="filtersCount > 0"
                    data-test="flows-reset"
                    :borders="false"
                    size="xs"
                    @click.stop="reset"
                >
                    {{ pluralized('filter', filtersCount, true) }}
                    <font-awesome-icon widthAuto :icon="faCircleXmark" />
                </vx-badge>
            </template>
            <template v-slot:form>
                <form
                    @submit.prevent="
                        active = false;
                        emit('apply');
                    "
                >
                    <filter-label :canReset="!!props.modelValue.query" @reset="updateModelValue('query', undefined)">
                        Keyword Search
                    </filter-label>
                    <vx-input
                        type="text"
                        data-test="flows-query"
                        placeholder="Search"
                        :modelValue="props.modelValue.query"
                        @update:modelValue="updateModelValue('query', $event)"
                        maxlength="256"
                        size="lg"
                        class="mb-4"
                    >
                        <template v-slot:right>
                            <font-awesome-icon widthAuto class="text-xs" :icon="faMagnifyingGlass" />
                        </template>
                    </vx-input>

                    <div class="flex gap-2 pt-4">
                        <vx-button
                            data-test="flows-cancel"
                            type="button"
                            size="lg"
                            color="muted-light"
                            @click="
                                active = false;
                                emit('reset');
                            "
                        >
                            Cancel
                        </vx-button>
                        <vx-button data-test="flows-apply" size="lg" type="submit" block>
                            Apply
                            <font-awesome-icon widthAuto :icon="faCircleCheck"></font-awesome-icon>
                        </vx-button>
                    </div>
                </form>
            </template>
        </vx-filterable>
    </div>
</template>

<script setup>
import { faCircleCheck, faMagnifyingGlass, faCircleXmark } from '@fortawesome/pro-solid-svg-icons';
import { VxBadge, VxButton, VxFilterable, VxInput } from '@voxie/frontend-components';
import { computed, ref } from 'vue';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import FilterLabel from '~/components/general/FilterLabel.vue';
import { pluralized } from '~/components/filters';

const props = defineProps({
    modelValue: {
        type: Object,
        required: true,
    },
    loading: {
        type: Boolean,
        default: false,
    },
});

const emit = defineEmits(['update:modelValue', 'apply', 'reset', 'new']);

const active = ref(false);

const toggleFilterable = (event) => {
    active.value = event;
};

const updateModelValue = (key, value) => {
    emit('update:modelValue', {
        ...props.modelValue,
        [key]: value,
    });
};

const filtersCount = computed(() => (props.modelValue.query ? 1 : 0));

const reset = () => {
    emit('reset');
};
</script>
